import React, { useEffect, useRef, useState } from 'react';
import { Button, Dropdown, Input, message, Tag } from 'antd';

import Icofont from 'react-icofont';
import EmojiPicker from 'emoji-picker-react';

import { CopyToClipboard } from 'react-copy-to-clipboard';

const { TextArea } = Input;
const { CheckableTag } = Tag;

// https://reactjsexample.com/react-emoji-picker-component/
export default function EmojiTextArea(props) {
    const { rows, value, onChange, defaultText, setAsDefault, copyButton } = props;
    const [visible, setVisible] = useState(false);
    const [position, setPosition] = useState({ start: 0, end: 0 });
    const area = useRef();

    useEffect(() => {
        if (area
            && value
            && area.current
            && position.start <= position.end
            && value.length > position.start
            && value.length > position.end
            && area.current.resizableTextArea
            && area.current.resizableTextArea.textArea) {
            area.current.resizableTextArea.textArea.selectionStart = position.start;
            area.current.resizableTextArea.textArea.selectionEnd = position.end;
        }
    }, [position]);

    const customNames = {
        people: "",
        foods: "",
        nature: "",
        activity: "",
        objects: "",
        places: "",
        flags: "",
        symbols: "",
    };
    const groupVisibility = {
        smileys_people: true,
        animals_nature: false,
        food_drink: false,
        travel_places: false,
        activities: false,
        objects: false,
        symbols: true,
        flags: false,
        recently_used: true,
    };
    const onEmojiClick = (event, emojiObject) => {
        let v = value || "";
        var begin = v.substring(0, area.current.resizableTextArea.textArea.selectionStart)
        var end = v.substring(area.current.resizableTextArea.textArea.selectionEnd, v.length)
        setPosition({
            start: area.current.resizableTextArea.textArea.selectionStart + emojiObject.emoji.length,
            end: area.current.resizableTextArea.textArea.selectionStart + emojiObject.emoji.length
        });
        area.current.focus()
        onChange(begin + emojiObject.emoji + end);
    };

    return (
        <>

            <TextArea ref={area} value={value} onChange={onChange} rows={rows} />
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                    {(defaultText !== undefined) && <Dropdown.Button
                        size="small"
                        menu={{
                            items: [
                                {
                                    label: 'Установить как значение "По умолчанию"',
                                    key: '1',
                                }
                            ],
                            onClick: () => {
                                if (setAsDefault) {
                                    setAsDefault(value)
                                }
                            },
                        }} onClick={() => {
                            onChange(defaultText)
                        }}>
                        По умолчанию
                    </Dropdown.Button>}
                    {copyButton && <CopyToClipboard text={value}
                        onCopy={() => message.success("Скопировано")}>
                        <CheckableTag
                            style={{
                                marginBottom: "5px",
                                marginRight: "0px"
                            }}
                            key={"copy"}
                            // checked={visible}
                            // onChange={checked => setVisible(checked)}
                        >
                            <i className="fa fa-files-o"></i>
                        </CheckableTag>
                        {/* <Button><i className="fa fa-files-o"></i></Button> */}
                    </CopyToClipboard>}
                </div>
                {/* {(defaultText) && <CheckableTag
                    style={{
                        marginBottom: "5px",
                        marginRight: "0px"
                    }}
                    key={"defaultText"}
                    onChange={checked => {
                        onChange(defaultText)
                    }}
                >
                    По умолчанию
                </CheckableTag>} */}
                <CheckableTag
                    style={{
                        marginBottom: "5px",
                        marginRight: "0px"
                    }}
                    key={"visible"}
                    checked={visible}
                    onChange={checked => setVisible(checked)}
                >
                    <Icofont icon="meetme" />
                </CheckableTag>
            </div>
            {visible && <EmojiPicker
                native={true}
                disableSearchBar
                disableDiversityPicker
                disableSkinTonePicker
                onEmojiClick={onEmojiClick}
                groupVisibility={groupVisibility}
                customCategoryNames={customNames}
                pickerStyle={{ width: "100%", marginTop: "5px" }} />}
        </>
    );
}
